export default __webpack_public_path__ + "static/memorabid-logo-5407bcbd31a759fdc8c8242856eca441.png";